/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Listening_This_WeekInputs */

const en_why_listening_listening_this_week = /** @type {(inputs: Why_Listening_Listening_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listening this week`)
};

const es_why_listening_listening_this_week = /** @type {(inputs: Why_Listening_Listening_This_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha esta semana`)
};

/**
* | output |
* | --- |
* | "Listening this week" |
*
* @param {Why_Listening_Listening_This_WeekInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_listening_this_week = /** @type {((inputs?: Why_Listening_Listening_This_WeekInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Listening_This_WeekInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_listening_this_week(inputs)
	return en_why_listening_listening_this_week(inputs)
});